// src/components/dashboard/DashboardTabs.js
import React from "react";
import { FiChevronDown } from "react-icons/fi";
import "./DashboardTabs.css";

export default function DashboardTabs({
  nivel,
  genero,
  duracao,
  setNivel,
  setGenero,
  setDuracao,
}) {
  const isNotTodos = (v) => (v || "").toLowerCase() !== "todos";

  return (
    <div className="dashboard-filters">
      {/* Nível */}
      <div className={`filter-wrapper ${isNotTodos(nivel) ? "is-active" : ""}`}>
        <select
          className="filter-select"
          value={nivel}
          onChange={(e) => setNivel(e.target.value)}
        >
          <option value="Todos">Todos</option>
          <option value="Iniciante">Iniciante</option>
          <option value="Intermediário">Intermediário</option>
          <option value="Avançado">Avançado</option>
        </select>

        <div className="filter-label">
          Nível <FiChevronDown className="filter-icon" />
        </div>
      </div>

      {/* Gêneros */}
      <div className={`filter-wrapper ${isNotTodos(genero) ? "is-active" : ""}`}>
        <select
          className="filter-select"
          value={genero}
          onChange={(e) => setGenero(e.target.value)}
        >
          <option value="Todos">Todos</option>
          <option value="Mundo Real">Mundo Real</option>
          <option value="Educação">Educação</option>
          <option value="Cotidiano">Cotidiano</option>
        </select>

        <div className="filter-label">
          Gêneros <FiChevronDown className="filter-icon" />
        </div>
      </div>

      {/* Duração */}
      <div className={`filter-wrapper ${isNotTodos(duracao) ? "is-active" : ""}`}>
        <select
          className="filter-select"
          value={duracao}
          onChange={(e) => setDuracao(e.target.value)}
        >
          <option value="Todos">Todos</option>
          <option value="Curta">Curta</option>
          <option value="Média">Média</option>
          <option value="Longa">Longa</option>
        </select>

        <div className="filter-label">
          Duração <FiChevronDown className="filter-icon" />
        </div>
      </div>
    </div>
  );
}
